import script from "./MobilePay.vue?vue&type=script&setup=true&lang=ts"
export * from "./MobilePay.vue?vue&type=script&setup=true&lang=ts"

import "./MobilePay.vue?vue&type=style&index=0&id=7420428d&lang=scss&scoped=true"

import exportComponent from "/root/workspace/dec_website_mQOS/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7420428d"]])

export default __exports__